import SearchField from './styled';

export default SearchField;
